import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import {
  CustomTracker,
  CustomTrackerProps,
} from 'src/app/data/dietitian/domain/custom_tracker/custom_tracker';
import { TrackerType } from 'src/app/data/tracker/domain/tracker/tracker_type';

import { Dietitian } from '../../../../../../data/dietitian/domain/dietitian';
import { NewCustomTrackerModalFacade } from './new-custom-tracker-modal.facade';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'msd-custom-new-tracker-modal',
  templateUrl: './new-custom-tracker-modal.component.html',
  styleUrls: ['./new-custom-tracker-modal.component.scss'],
  providers: [NewCustomTrackerModalFacade],
})
export class NewCustomTrackerModalComponent implements OnInit {
  @Input() dietitian: Dietitian;
  @Output() cancel = new EventEmitter();
  @Output() validate = new EventEmitter<CustomTracker>();
  public newTrackerForm: FormGroup;
  public isLoading = false;
  public error?: string;

  constructor(
    private bsModalRef: BsModalRef,
    private facade: NewCustomTrackerModalFacade,
  ) {
    // Nada
  }

  ngOnInit(): void {
    this.newTrackerForm = new FormGroup({
      type: new FormControl('', [Validators.required]),
      name: new FormControl('', [
        Validators.required,
        Validators.minLength(1),
        Validators.maxLength(30),
      ]),
      rangeType: new FormControl('', [Validators.required]),
      maxValue: new FormControl('', [Validators.required]),
    });
  }

  hideModal() {
    this.bsModalRef.hide();
  }

  createCustomTracker() {
    const trackerName = this.newTrackerForm.get('name')?.value;
    const rangeType = this.newTrackerForm.get('rangeType')
      ?.value as TrackerType;
    const maxValue = this.newTrackerForm.get('maxValue')?.value;
    const diaryType = this.newTrackerForm.get('type')?.value;

    if (
      !trackerName ||
      !rangeType ||
      !maxValue ||
      !this.dietitian ||
      !diaryType
    ) {
      return;
    }

    this.isLoading = true;
    this.error = undefined;

    this.facade
      .saveCustomTracker({
        diaryType,
        dietitianId: this.dietitian.dietitianId,
        max: maxValue,
        name: trackerName,
        type: rangeType,
      } as CustomTrackerProps)
      .then((customTracker) => {
        this.validate?.emit(customTracker);
        this.hideModal();
      })
      .catch((err) => {
        this.error = err;
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  get typeInvalid(): boolean | undefined {
    return (
      !this.newTrackerForm.get('type')?.valid &&
      (this.newTrackerForm.get('type')?.touched ||
        this.newTrackerForm.get('type')?.dirty)
    );
  }

  get nameInvalid(): boolean | undefined {
    return (
      !this.newTrackerForm.get('name')?.valid &&
      (this.newTrackerForm.get('name')?.touched ||
        this.newTrackerForm.get('name')?.dirty)
    );
  }

  get rangeTypeInvalid(): boolean | undefined {
    return (
      !this.newTrackerForm.get('rangeType')?.valid &&
      (this.newTrackerForm.get('rangeType')?.touched ||
        this.newTrackerForm.get('rangeType')?.dirty)
    );
  }

  get maxValueInvalid(): boolean | undefined {
    return (
      !this.newTrackerForm.get('maxValue')?.valid &&
      (this.newTrackerForm.get('maxValue')?.touched ||
        this.newTrackerForm.get('maxValue')?.dirty)
    );
  }
}
